import { render } from "./ProductQuoteTab.vue?vue&type=template&id=535ec03a&ts=true"
import script from "./ProductQuoteTab.vue?vue&type=script&lang=ts"
export * from "./ProductQuoteTab.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__